import React from 'react';
import { FaLinkedin, FaEnvelope, FaTwitter } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-info">
            <h3>Reese Kunz</h3>
            <p>Content Strategist & Marketing Professional</p>
          </div>

          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#about">About</a></li>
              <li><a href="#experience">Experience</a></li>
              <li><a href="#featured-work">Featured Work</a></li>
              <li><a href="#skills">Skills</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-contact">
            <h4>Connect</h4>
            <div className="footer-social">
              <a
                href="https://linkedin.com/in/reesekunz"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <FaLinkedin />
              </a>
              <a
                href="mailto:reesejkunz@gmail.com"
                className="social-link"
              >
                <FaEnvelope />
              </a>
              <a
                href="https://x.com/reesekunz"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
              >
                <FaTwitter />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            © {currentYear} Reese Kunz. Built using ☕ and React.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;